"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const calculateAlignItems = (props) => {
    if (props.alignItemsCenter) {
        return 'center';
    }
    return '';
};
const Flex = styled_components_1.default.div `
  display: flex;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  align-items: ${calculateAlignItems};
`;
exports.Flex = Flex;
